import styled from "styled-components";
import Links from "features/checklist/styles/Links.styled";
import { TertiaryHeader } from "features/shared/styles/typography/TertiaryHeader.styled";

const PageHeader = styled.div<{ $isWithIcon?: boolean }>`
  ${TertiaryHeader} {
    margin-bottom: 8px;
  }

  ${Links} {
    margin-top: 24px;
  }
`;

export default PageHeader;
